import { render } from "./SaleBoard.vue?vue&type=template&id=0ccb79fe&ts=true"
import script from "./SaleBoard.vue?vue&type=script&lang=ts"
export * from "./SaleBoard.vue?vue&type=script&lang=ts"

import "./SaleBoard.vue?vue&type=style&index=0&id=0ccb79fe&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__